import React from "react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export default function PaginationFooter({ page, setPage, pageSize, setPageSize, total }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-border bg-[#0A0A0A]/40">
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <span>Tampilkan</span>
        <Select value={String(pageSize)} onValueChange={(v) => setPageSize(Number(v))}>
          <SelectTrigger data-testid="page-size-select" className="h-8 w-24 bg-[#0A0A0A] border-border">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="10">10</SelectItem>
            <SelectItem value="20">20</SelectItem>
            <SelectItem value="50">50</SelectItem>
            <SelectItem value="0">Semua</SelectItem>
          </SelectContent>
        </Select>
        <span className="font-mono">Total {total}</span>
      </div>
      {pageSize > 0 && total > pageSize && (
        <div className="flex items-center gap-2">
          <Button
            data-testid="prev-page-button"
            variant="outline"
            size="sm"
            className="border-border bg-transparent h-8"
            disabled={page <= 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
          >
            Prev
          </Button>
          <span data-testid="page-info" className="text-xs text-muted-foreground font-mono px-2">
            Halaman {page} dari {totalPages}
          </span>
          <Button
            data-testid="next-page-button"
            variant="outline"
            size="sm"
            className="border-border bg-transparent h-8"
            disabled={page >= totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
}
